const bladeApi = Symbol('bladeApiKey');

export default bladeApi;
